import React from 'react';
import Tabela from '~/Components/TabelaDinamica/Tabela';
import moment from 'moment';

const brl = (v) =>
  (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const colunas = [
  { key: 'codigo_cedente', title: 'Cedente', ordenacao: true },
  { key: 'codigo_portador', title: 'Portador', ordenacao: true },
  {
    key: 'valor',
    title: 'Valor',
    ordenacao: true,
    render: (value) => brl(value),
  },
  {
    key: 'data_vencimento',
    title: 'Dt. Vencimento',
    ordenacao: true,
    render: (value) =>
      value ? moment(value).format('DD/MM/YYYY') : '-',
  },
  { key: 'prorrogacoes', title: 'Prorrogações', ordenacao: true },
  { key: 'banco_cheque_rec', title: 'Banco', ordenacao: true },
  { key: 'agencia_cheque_rec', title: 'Agência', ordenacao: true },
  { key: 'numero_cheque_rec', title: 'Número', ordenacao: true },
];

const GridAbertos = ({ dados }) => (
  <div style={{ maxHeight: 400, overflowY: 'auto' }}>
    <Tabela
      colunas={colunas}
      dados={dados || []}
      striped
      hover
    />
  </div>
);

export default GridAbertos;
